import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsJobsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsJobStack = createStackNavigator();

const BatchDetailsJobNavigator = () => {
  return (
    <BatchDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchDetailsJobsConfig.map(({ Component, name }) => (
        <BatchDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsJobStack.Navigator>
  );
};

export { BatchDetailsJobNavigator };
